var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedditCommentsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.reddit{fill:url(#reddit-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reddit-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7b10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#f95c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef151d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "reddit",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M74.16393,52.50386c0-2.90183-2.35243-5.25426-5.25426-5.25426-1.44344,0-2.75024.58274-3.69985,1.5249-3.53079-2.52069-8.35327-4.15186-13.72182-4.4116l2.24083-11.57946,7.70717,1.65821c.08381,1.9961,1.71613,3.59198,3.73279,3.59198,2.07023,0,3.74855-1.67826,3.74855-3.74855s-1.67832-3.74855-3.74855-3.74855c-1.46383,0-2.7181.84735-3.33527,2.07074l-8.64733-1.86055c-.2429-.05041-.50414-.0055-.71404.13474-.21082.13841-.35656.35656-.40423.60405l-2.48419,12.83912c-5.79884.07837-11.02892,1.76219-14.79357,4.44987-.94961-.94216-2.25642-1.5249-3.69985-1.5249-2.90183,0-5.25426,2.35243-5.25426,5.25426,0,2.13244,1.2726,3.96418,3.09787,4.78776-.09831.57535-.15468,1.15957-.15468,1.75331,0,8.13798,9.50087,14.73513,21.22074,14.73513s21.22074-6.59715,21.22074-14.73513c0-.59374-.05637-1.17796-.15468-1.75331,1.82526-.82358,3.09787-2.65531,3.09787-4.78776ZM38.01259,56.25241c0-2.07029,1.67832-3.74855,3.74855-3.74855s3.74855,1.67826,3.74855,3.74855-1.67826,3.74849-3.74855,3.74849-3.74855-1.67826-3.74855-3.74849ZM58.90587,66.39016c-2.95516,1.53808-5.93049,2.30803-8.90582,2.30803s-5.95065-.76996-8.90582-2.30803c-.45922-.23924-.63796-.8057-.39873-1.26584.23832-.45922.80479-.64071,1.26584-.39873,5.40985,2.81584,10.66755,2.81584,16.0774,0,.46014-.24107,1.02752-.0605,1.26584.39873.23924.46014.0605,1.02661-.39873,1.26584ZM58.42293,60.0009c-2.07023,0-3.74855-1.67826-3.74855-3.74849s1.67832-3.74855,3.74855-3.74855,3.74855,1.67826,3.74855,3.74855-1.67826,3.74849-3.74855,3.74849Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M43.89158,39.33017l-.01306,3.38744-4.21969-3.38744h-10.40119c-1.88968,0-3.42157-1.53189-3.42157-3.42157v-6.2671c0-1.88968,1.53189-3.42157,3.42157-3.42157h14.63394c1.88968,0,3.42157,1.53189,3.42157,3.42157v6.2671c0,1.88968-1.53189,3.42157-3.42157,3.42157Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedditCommentsScraper);
export default __webpack_public_path__ + "static/media/reddit-comments-scraper.00a5b5b509afe2f44e623dc84017b036.svg";
export { ForwardRef as ReactComponent };